// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { BreadcrumbTokens } from './type';

const breadcrumbTokens: BreadcrumbTokens = {
  breadcrumbFontSize: 'Font-14',
  breadcrumbFontColor: 'Neutral-text-5',
  breadcrumbFontWeight: 'Weight-regular',
  breadcrumbLinkColor: 'Neutral-text-3',
  breadcrumbLinkHoverColor: 'Brand-5',
  breadcrumbDefaultLinkColor: 'Brand-6',
  breadcrumbDefaultLinkHoverColor: 'Brand-5',
  breadcrumbDefaultLinkActiveColor: 'Brand-7',
  breadcrumbListPaddingY: 'Spacing-4',
  breadcrumbListItemBorderRadius: 'Radius-default',
  breadcrumbListItemWrapperPaddingX: 'Spacing-4',
  breadcrumbListItemPaddingX: 'Spacing-8',
  breadcrumbListItemPaddingY: 'Spacing-5',
  breadcrumbListItemHoverBackgroundColor: 'Neutral-fill-2',
  breadcrumbListItemHoverFontColor: 'Neutral-text-3',
  breadcrumbPrevFontWeight: 'Weight-regular',
  breadcrumbSeparatorMarginX: 'Spacing-8',
  breadcrumbIconBackgroundColor: 'Neutral-text-4',
  breadcrumbDownIconSize: 'Font-14',
};

export default breadcrumbTokens;
